import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function SafetyPage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  const faqs = [
    {
      question: 'ボランティアの安全性・信頼性は？',
      answer: '登録時に同意事項を確認・同意のうえ開始します。サービス内の報告フォームからいつでも連絡可能。運営が迅速に対応します。'
    },
    {
      question: 'ボランティア登録時の同意事項の内容は？',
      answer: `ボランティアの皆さまには、以下の事項にご同意いただいています：

<div class="bg-blue-50 border-l-4 border-blue-400 p-6 my-4 rounded-r-lg">
  <h4 class="font-bold text-blue-800 mb-4 text-lg">🧒 子どもの安全・権利の保護</h4>
  <ul class="space-y-2 text-blue-700">
    <li>• こどもを真ん中に。権利・尊厳・安全・プライバシーを大切にすることにご協力ください。</li>
    <li>• 多様性への配慮と言葉づかいを心がけ、いかなるハラスメント（言動・身体・性的・パワー）も行わないでください。</li>
  </ul>
</div>

<div class="bg-green-50 border-l-4 border-green-400 p-6 my-4 rounded-r-lg">
  <h4 class="font-bold text-green-800 mb-4 text-lg">📱 サービス利用・アカウント管理</h4>
  <ul class="space-y-2 text-green-700">
    <li>• サービス外の連絡先交換や他SNS・外部ツールへの誘導は控え、連絡はサービス内機能のみをご利用ください。</li>
    <li>• 第三者へのアカウントの譲渡や登録されたボランティア本人以外のアカウントの利用は行わないでください。</li>
    <li>• オフラインでの私的な面会・受け渡し・送迎等は行わないでください。</li>
  </ul>
</div>

<div class="bg-purple-50 border-l-4 border-purple-400 p-6 my-4 rounded-r-lg">
  <h4 class="font-bold text-purple-800 mb-4 text-lg">🎥 画面・資料の取り扱い</h4>
  <ul class="space-y-2 text-purple-700">
    <li>• 画面の録画・スクリーンショットは行わないでください（運営が明示した手順がある場合を除く）。</li>
    <li>• 画面共有は学習に必要な範囲で。私的空間の映り込みの指示や、服装・容姿・身体への言及は控えてください。</li>
    <li>• 資料の共有はサービスの所定機能でのみ行い。外部リンクや実行形式ファイルの送付、個人情報を含む書類の共有は控えてください。</li>
  </ul>
</div>

<div class="bg-orange-50 border-l-4 border-orange-400 p-6 my-4 rounded-r-lg">
  <h4 class="font-bold text-orange-800 mb-4 text-lg">🔒 個人情報・適切な指導</h4>
  <ul class="space-y-2 text-orange-700">
    <li>• 指導中に知り得た個人情報や相談内容は目的外に使わず、情報の漏えいがないようご配慮ください。</li>
    <li>• 不適切な話題（暴力・性的・年齢不相応等）や勧誘（宗教・政治・営業）、金品・ギフトコードのやり取りは行わないでください。</li>
  </ul>
</div>

<div class="bg-red-50 border-l-4 border-red-400 p-6 my-4 rounded-r-lg">
  <h4 class="font-bold text-red-800 mb-4 text-lg">🚨 緊急時・相談対応</h4>
  <ul class="space-y-2 text-red-700">
    <li>• 安全に関わる心配（自傷・虐待の兆し等）を見つけたら、秘密の約束はせず、速やかに報告ボタンでご連絡ください。</li>
    <li>• 迷ったときは一人で判断せず、報告ボタンや運営・施設スタッフへご相談ください。</li>
  </ul>
</div>

<div class="bg-gray-50 border-l-4 border-gray-400 p-6 my-4 rounded-r-lg">
  <h4 class="font-bold text-gray-800 mb-4 text-lg">⚖️ 規約遵守</h4>
  <ul class="space-y-2 text-gray-700">
    <li>• 本お願いに沿った運用にご協力ください。守れない場合はアカウント停止や、必要に応じ関係機関への連絡等の対応があることをご理解ください。</li>
  </ul>
</div>`
    },
    {
      question: '謝金や税務の対応は？',
      answer: '源泉徴収や消費税の計算をサービス側でサポート。居場所側の手間を最小化します。'
    },
    {
      question: '何か問題があった時はどうすればいい？',
      answer: 'サービス内の報告フォームから即座に連絡できます。また、メールでのサポートも提供しています。'
    },
    {
      question: '個人情報の取り扱いは？',
      answer: 'プライバシーポリシーに基づき、適切に管理・保護しています。必要最小限の情報のみを収集し、第三者への提供は行いません。'
    }
  ];

  const safetyFeatures = [
    {
      icon: 'ri-shield-check-line',
      title: '登録時の同意確認',
      description: '丁寧な同意事項の確認を経てからスタート'
    },
    {
      icon: 'ri-message-3-line',
      title: '報告フォーム',
      description: 'サービス内から不安や違和感を即座に連絡'
    },
    {
      icon: 'ri-customer-service-line',
      title: 'メールサポート',
      description: '[サポート用メールアドレス]で直接相談'
    },
    {
      icon: 'ri-time-line',
      title: '迅速な対応',
      description: '運営チームが速やかに問題解決をサポート'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="pt-20 pb-16 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            安全をいちばんに。迷ったらすぐ相談。
          </h1>
          <p className="text-lg text-gray-600 mb-4">
            ボラタスは安全で安心な学習支援環境を提供します
          </p>
          <p className="text-base text-teal-700 font-medium">
            支援者が安心して活動できることが、こどもたちの安全な学びの土台になります
          </p>
          <div className="w-24 h-1 bg-teal-500 mx-auto mt-8"></div>
        </div>
      </section>

      {/* Safety Features */}
      <section className="py-16 px-4">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-12">
            安全のための取り組み
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {safetyFeatures.map((feature, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-blue-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${feature.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-3">{feature.title}</h3>
                <p className="text-gray-600 leading-relaxed">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Volunteer Consent Screen */}
      <section className="py-16 px-4 bg-blue-50">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-12">
            ボランティアへの同意をお願いする画面
          </h2>
          <div className="bg-white rounded-lg shadow-lg p-8">
            <div className="text-center mb-8">
              <img 
                src="https://static.readdy.ai/image/8766ff501ca5aa7943b16e981fd86369/1b136e68042237c21151697496012cfb.png"
                alt="ボランティア同意画面"
                className="w-full max-w-2xl mx-auto rounded-lg shadow-md"
              />
              <p className="text-gray-600 mt-4 text-sm">ボランティア活動開始前の同意確認画面</p>
            </div>
            <div className="text-center">
              <p className="text-lg text-gray-700 leading-relaxed">
                ボランティア活動を開始する前に、安全で質の高い学習支援を提供するため、<br />
                詳細な同意事項の確認をお願いしています。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16 px-4 bg-gray-50">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-12">
            よくある質問
          </h2>
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div key={index} className="bg-white rounded-lg border border-gray-200 overflow-hidden">
                <button
                  className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors cursor-pointer"
                  onClick={() => setOpenFaq(openFaq === index ? null : index)}
                >
                  <span className="font-semibold text-gray-900">{faq.question}</span>
                  <i className={`ri-arrow-${openFaq === index ? 'up' : 'down'}-s-line text-gray-500`}></i>
                </button>
                {openFaq === index && (
                  <div className="px-6 pb-4">
                    <div className="text-gray-600 leading-relaxed" dangerouslySetInnerHTML={{ __html: faq.answer }} />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-16 px-4">
        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-r from-teal-500 to-blue-500 rounded-2xl p-8 text-white text-center">
            <h2 className="text-2xl md:text-3xl font-bold mb-4">
              困ったことがあれば、いつでもご連絡ください
            </h2>
            <p className="text-lg mb-8 opacity-90">
              私たちは皆さまの安全と安心を最優先に考えています
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="bg-white text-teal-600 px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer">
                サービス内で報告
              </button>
              <button className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg font-semibold hover:bg-white hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer">
                メールで問い合わせる
              </button>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
